module.exports = "<div id=\"slider-area\">\n    <app-slider></app-slider>\n</div>"